<script lang="ts" setup>
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { DetailsCarItemData } from '@autobid/ui/types/Car'
import { useCarAdditionalInfo } from '@autobid/ui/composables/car/useCarAdditionalInfo'
import { formatStartDate } from '@autobid/ui/utils/auctions/formatStartDate'

interface Props {
  car: DetailsCarItemData | PreviewItemData
}

const props = defineProps<Props>()

const { additionalInfo, sortedAdditionalInfo } = useCarAdditionalInfo(
  props.car.dataAddition,
)
</script>

<template>
  <div
    v-if="additionalInfo?.length"
    style="background-color: #ffc000"
    class="my-4"
  >
    <div class="ml-4 w-full list-decimal space-y-2 p-2 px-10 !text-black">
      <div
        v-for="(item, index) in sortedAdditionalInfo"
        :key="item.id"
        class="flex items-start gap-4"
      >
        <div class="text-2xl font-bold" style="color: black">
          {{ index + 1 }}.
        </div>
        <div class="flex flex-col gap-1">
          <div class="mb-1 text-2xl font-bold" style="color: black">
            {{ $t('addition-info.data-addition') }}
            ({{
              formatStartDate(item.additionTime, { showFullDate: true, $t })
            }})
          </div>
          <div style="color: black">
            {{ `${item.categoryLabel}: ` }}{{ item.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
